import { FC, forwardRef } from "react";
import { IonLoading } from "@ionic/react";
import { AllieLoadingProps } from "./Loading.types";

export const AllieLoading: FC<AllieLoadingProps> = forwardRef(
  ({ isOpen, ...props }, ref) => (
  <IonLoading isOpen={isOpen} ref={ref} data-testid="global-loading-spinner" {...props} />
));
